export enum OpportunityStatus {
  Draft,
  Open,
  Archived,
  Expired,
}
